import createIcon from '../../createIcon';

/**
 * @component @name Phishing
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgOS41QzE5IDguMiAxOC4xNiA3LjEgMTcgNi42OFYyLjVIMTVWNi42OEMxMy44NCA3LjEgMTMgOC4yIDEzIDkuNUMxMyAxMC44IDEzLjg0IDExLjkgMTUgMTIuMzJWMTUuNUMxNSAxNy43MSAxMy4yMSAxOS41IDExIDE5LjVDOC43OSAxOS41IDcgMTcuNzEgNyAxNS41VjE0LjVIMTBMNSA5LjVWMTUuNUM1IDE4LjgxIDcuNjkgMjEuNSAxMSAyMS41QzE0LjMxIDIxLjUgMTcgMTguODEgMTcgMTUuNVYxMi4zMkMxOC4xNiAxMS45IDE5IDEwLjggMTkgOS41Wk0xNiAxMC41QzE1LjQ1IDEwLjUgMTUgMTAuMDUgMTUgOS41QzE1IDguOTUgMTUuNDUgOC41IDE2IDguNUMxNi41NSA4LjUgMTcgOC45NSAxNyA5LjVDMTcgMTAuMDUgMTYuNTUgMTAuNSAxNiAxMC41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Phishing = createIcon('Phishing', [
  [
    'path',
    {
      d: 'M19 9.5C19 8.2 18.16 7.1 17 6.68V2.5H15V6.68C13.84 7.1 13 8.2 13 9.5C13 10.8 13.84 11.9 15 12.32V15.5C15 17.71 13.21 19.5 11 19.5C8.79 19.5 7 17.71 7 15.5V14.5H10L5 9.5V15.5C5 18.81 7.69 21.5 11 21.5C14.31 21.5 17 18.81 17 15.5V12.32C18.16 11.9 19 10.8 19 9.5ZM16 10.5C15.45 10.5 15 10.05 15 9.5C15 8.95 15.45 8.5 16 8.5C16.55 8.5 17 8.95 17 9.5C17 10.05 16.55 10.5 16 10.5Z',
      key: '7yvmjf',
    },
  ],
]);

export default Phishing;
